if (!customElements.get('home-media')) {
  class HomeMedia extends HTMLElement {
    constructor() {
      super();
      this.mainSlidesMobile = Number(this.getAttribute('data-main-slides-mobile')) || 2;
      this.subSlidesPc = Number(this.getAttribute('data-sub-slides-pc')) || 4;
      this.subSlidesMobile = Number(this.getAttribute('data-sub-slides-mobile')) || 5;
      this.subAutoplay = this.getAttribute('data-sub-autoplay') === 'true';
      this.subAutoplaySpeed = Number(this.getAttribute('data-sub-autoplay-speed')) || 3;
      this.init();
    }

    init() {
      // 主要图轮播（无 pagination）
      const mainSwiperEl = this.querySelector('.home-media__main-swiper');
      if (mainSwiperEl) {
        this.mainSwiper = new Swiper(mainSwiperEl, {
          slidesPerView: this.mainSlidesMobile,
          spaceBetween: 8,
          loop: true,
          navigation: {
            prevEl: this.querySelector('.home-media__main-nav-btn--prev'),
            nextEl: this.querySelector('.home-media__main-nav-btn--next')
          },
          breakpoints: {
            768: {
              slidesPerView: 1,
              spaceBetween: 0
            }
          }
        });
      }

      // 次要图轮播（有 pagination）
      const subSwiperEl = this.querySelector('.home-media__sub-swiper');
      if (subSwiperEl) {
        const subPrevBtn = this.querySelector('.home-media__nav-btn--prev');
        const subNextBtn = this.querySelector('.home-media__nav-btn--next');

        this.subSwiper = new Swiper(subSwiperEl, {
          slidesPerView: this.subSlidesMobile,
          spaceBetween: 8,
          loop: true,
          autoplay: this.subAutoplay ? {
            delay: this.subAutoplaySpeed * 1000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true
          } : false,
          pagination: {
            el: this.querySelector('.home-media__sub-pagination'),
            clickable: true
          },
          breakpoints: {
            768: {
              slidesPerView: this.subSlidesPc,
              spaceBetween: 12
            }
          }
        });

        if (subPrevBtn) {
          subPrevBtn.addEventListener('click', () => {
            this.subSwiper.slidePrev();
          });
        }
        if (subNextBtn) {
          subNextBtn.addEventListener('click', () => {
            this.subSwiper.slideNext();
          });
        }

        // 移动端次要图左右按钮
        const subMobilePrev = this.querySelector('.home-media__sub-mobile-nav--prev');
        const subMobileNext = this.querySelector('.home-media__sub-mobile-nav--next');
        if (subMobilePrev) {
          subMobilePrev.addEventListener('click', () => {
            this.subSwiper.slidePrev();
          });
        }
        if (subMobileNext) {
          subMobileNext.addEventListener('click', () => {
            this.subSwiper.slideNext();
          });
        }
      }
    }
  }

  customElements.define('home-media', HomeMedia);
}
